module.exports = __webpack_public_path__ + "static/img/cont34 (4).fc01cbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont34 (4).jpg
// module id = SsI7
// module chunks = 0